export default class ConfirmController {

  constructor($rootScope, $state, $stateParams, User, UIService) {
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.User = User;
    this.UI = UIService;
    this.error = {
      password: false,
      passwordShort: false,
      unAuthorized: false,
      network: false
    };

    this.waiting = false;

    this.password = '';
    this.password2 = '';
    this.id = $stateParams.id || null;

    if (this.id == null) {
      this.$state.go('app.dashboard');
    }
  }

  hasErrors = () => {
    return Object.keys(this.error).some(e => this.error[e]);
  };

  confirm = () => {
    this.error.network = false;
    this.error.unAuthorized = false;

    if (this.password === this.password2) { // Check for confirmation
      this.error.password = false;
      if (this.password.length > 6) { // Check for minimum size
        this.waiting = true;
        this.error.passwordShort = false;
        this.User.setPassword({
          access_token: this.id
        }, {
          newPassword: this.password
        }).$promise.then((ok) => {
          this.waiting = false;
          this.$state.go('auth.login', {firstLogin: true});
        }).catch((err) => {
          this.waiting = false;
          if (err && err.status === 401) {
            this.error.unAuthorized = true;
          } else {
            this.error.network = true;
          }
        });
      } else {
        this.error.passwordShort = true;
      }
    } else {
      this.error.password = true;
    }
  }
}

ConfirmController.$inject = ['$rootScope', '$state', '$stateParams', 'User', 'UIService'];
